import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Takeover from '../takeover';
import classNames from 'classnames';
import { Button } from '../forms';
import ColorPicker from './color-picker';
import SaveButton from '../report/save-button';
import SpinnerDots from '../spinner/dots';
import { suggestColor } from './helpers/suggest-color';
import { REACT_APP_API_BASE } from '../../config';
import './save-district.scss';

class SaveDistrict extends Component {
    state = {
        isSaveDialogOpen: false,
        isFirstFetch: true,
        color: '#ff0000',
        textColor: '#ff0000',
        addWatcher: false,
        name: ''
    }

    nameChange(e) {
        const name = e.currentTarget.value;
        this.setState({
            name
        });
    }

    async toggleSaveDialog() {
        if (!this.state.isSaveDialogOpen) {
            if (this.props.id === 0) {
                this.setState({
                    isSaveDialogOpen: true,
                    isLoading: true
                });

                const res = await this.props.fetch(`${REACT_APP_API_BASE}/salesdistrict/spatialinfo/${this.props.type}${this.props.salesDistrictScenarioId ? `/${this.props.salesDistrictScenarioId}` : ''}`);
                const districts = await res.json();
                
                //Collect all colors
                const excludeColors = districts.map(district => {
                    const geoJSON = JSON.parse(district.geoJson);
                    if (geoJSON[0] && geoJSON[0].properties && geoJSON[0].properties.color) {
                        return geoJSON[0].properties.color
                    }

                    return '#ff0000';
                });

                const color = suggestColor(excludeColors);

                this.setState({
                    isLoading: false,
                    color: color,
                    textColor: color
                });
            } else {
                this.setState({
                    isSaveDialogOpen: true,
                    isLoading: false
                }); 
            }
        } else {
            this.setState({
                isSaveDialogOpen: !this.state.isSaveDialogOpen,
                isLoading: false
            });
        }

       
    }

    handleColorChange(e) {
        const color = e.currentTarget.value;
        this.setState({
            color
        });
    }

    componentDidUpdate() {
        const { name, color, addWatcher } = this.props;
        if (this.props.name && this.state.isFirstFetch) {
            this.setState({
                isFirstFetch: false,
                name,
                color,
                addWatcher
            });
        }
    }

    handleInputColorChange(e) {
        const color = e.currentTarget.value;

        //validate color
        if (/^#[0-9A-F]{6}$/i.test(color)) {
            this.setState({
                color,
                textColor: color
            });
        } else {
            this.setState({
                textColor: color === '' ? `#${color}` : color
            });
        }
    }

    cancel(e) {
        e.preventDefault(); 
        this.props.location.history.goBack();
    }

    toggleWatcher() {
        this.setState({
            addWatcher: !this.state.addWatcher
        });
    }

    render() {
        return (
            <>
                <Link className="create-district-map__cancel" to={this.props.type === 'foodservice' ? '/foodservice-scenario' : '/scenario'} onClick={(e) => this.cancel(e)}>Avbryt</Link>
                <button type="button" 
                        disabled={this.props.mapIsLoading}
                        className="form__button create-district-map__save"
                        onClick={() =>this.toggleSaveDialog()}>{this.props.mapIsLoading ? 'Laddar...' : 'Spara säljdistrikt'}</button>
                <Takeover isOpen={this.state.isSaveDialogOpen} toggleTakeover={() => this.toggleSaveDialog()} heading="Spara säljdistrikt">
                    <div className={classNames({
                        'save-district': true,
                        'save-district--is-saving': this.props.isSaving,
                        'save-district--is-loading': this.state.isLoading
                    })}>
                        {this.state.isSaveDialogOpen &&
                           <div className="save-district__content-outer">
                                <div className="save-district__content">
                                    <label className="create-district-map__label">Namn</label>
                                    <input className="create-district-map__input" type="text" onChange={(e) => this.nameChange(e)} value={this.state.name} />
                                    <label className="create-district-map__label" htmlFor="districtcolor">Färg på området i kartan, eller välj en egen</label>
                                    <ColorPicker color={this.state.color} 
                                                textColor={this.state.textColor} 
                                                onChange={(e) => this.handleColorChange(e)} 
                                                handleInputColorChange={(e) => this.handleInputColorChange(e)} 
                                                salesDistrictScenarioId={this.props.salesDistrictScenarioId} />
                                </div>
                                <div className={classNames({
                                    'save-district__long-loading-time': true,
                                    'save-district__long-loading-time--is-big': this.props.isLongLoadingTime
                                })}>
                                    <p>Ditt säljdistrikt är stort och tar lång tid att spara. Vänta medans vi jobbar på att skapa din nya säljyta!</p>
                                    <div className="save-district__loading-bar">
                                        <div style={{ width: `${this.props.loadingPercent}%`}} className="save-district__bar"></div>
                                    </div>
                                </div>
                                <div className="create-district-map__forms-footer">
                                    <SaveButton onClick={() => this.props.save(this.state)} 
                                                isLoading={this.props.isSaving}
                                                isSaved={this.props.isSaved} 
                                                text="Spara & visa distriktet" 
                                                textSaving="Sparar distriktet"
                                                textSaved="Distriktet sparades!"
                                                attr={{
                                                    disabled: this.props.isSaving
                                                }}
                                                modifiers={{
                                                    'create-district-map__create': true,
                                                    'report-save-btn--centered': true
                                                }} />
                                    <Button type="button" 
                                        modifiers={{
                                            'form__button--muted': true,
                                            'form__button--centered': true
                                        }}
                                        onClick={() => this.toggleSaveDialog()}>Avbryt</Button>
                                </div>
                            </div>
                        }
                        <SpinnerDots />
                    </div>
                </Takeover>
            </>
        );
    }
};

export default SaveDistrict;